import axios from 'axios'
import qs from 'qs';
import { message } from 'ant-design-vue';

axios.defaults.timeout = 6000
axios.defaults.baseURL = '/api/mldie';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  if(response.data.code === 200) {
    // 业务请求成功
    // message.success(response.data.message);
    return response.data;
  } else if (response.data.code === -1) {
    // 登录状态错误
    message.warning(response.data.message);
    router.push('/user')
  } else {
    message.warning(response.data.message)
  }
  return new Promise(() => {});
}, function (error) {
  return Promise.reject(error);
});

export default {
  getArticle: params => {
    return axios.get(`/article/${params}`).then(res => res);
  },
  articleLove: params => {
    return axios.get(`/article/love/${params}`).then(res => res);
  },
  getArticleList: params => {
    return axios.get('/article', params).then(res => res);
  },
  getArticleTags: params => {
    return axios.get('/tag', qs.stringify(params)).then(res => res);
  },
  getCategory: params => {
    return axios.get('/category', qs.stringify(params)).then(res => res);
  },
  getFriendLink: params => {
    return axios.get('/friendLink', qs.stringify(params)).then(res => res);
  },
  applyFriendLink: params => {
    return axios.post('/friendLink', params).then(res => res);
  },
}